(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/betslip.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/betslip.js');
"use strict";


const {
  styleClasses
} = svs.sportsbook.sbtech_api_impl;
const isSelfService = svs.core && svs.core.config && svs.core.config.data && svs.core.config.data.svsconfig && svs.core.config.data.svsconfig.isSelfService;

let _shouldShowBetslip = false;
let _isBetslipOpen = false;
let _betslipItemCount;
let _betslipEl;
let _betslipButtonEl;
let _betslipCol1;
let _betslipItemCountEl;
let _betslipTextEl;
let _betslipCol2;
let _sportsbookBetslipStateChangeHandler;

const betslipTransitionEvent = _ref => {
  let {
    propertyName
  } = _ref;
  return propertyName === 'opacity' && _betslipEl.classList.remove(styleClasses.BETSLIP_ADD_ITEM);
};
function render(onClick, onSportsbookStateChange) {
  _sportsbookBetslipStateChangeHandler = onSportsbookStateChange;
  if (_betslipEl) {
    return _betslipEl;
  }
  _betslipEl = document.querySelector('.js-sportsbook-betslip');
  _betslipButtonEl = _betslipEl.querySelector('.sportsbook-betslip--button');
  _betslipCol1 = _betslipEl.querySelector('.sportsbook-betslip--col1');
  _betslipCol2 = _betslipEl.querySelector('.sportsbook-betslip--col2');
  _betslipItemCountEl = _betslipEl.querySelector('.sportsbook-betslip--items-count');
  _betslipTextEl = _betslipEl.querySelector('.sportsbook-betslip--text');
  const betslipButtonEvent = () => {
    if (_betslipItemCount > 0 && onClick) {
      onClick();
    }
  };
  _betslipButtonEl.addEventListener('click', betslipButtonEvent, false);
  _betslipCol1.addEventListener('transitionend', betslipTransitionEvent, false);
  return function destroy() {
    _betslipButtonEl.removeEventListener('click', betslipButtonEvent);
    _betslipCol1.removeEventListener('transitionend', betslipTransitionEvent);
    _betslipEl = null;
    _betslipButtonEl = null;
    _betslipItemCountEl = null;
    _betslipCol1 = null;
    _betslipCol2 = null;
    _betslipTextEl = null;
  };
}
function toggle() {
  const shouldBetslipBeOpen = isSelfService ? true : _betslipItemCount > 0;
  const doOpen = shouldBetslipBeOpen && !_isBetslipOpen;
  if (!_betslipEl || !_shouldShowBetslip) {
    return;
  }
  if (svs.sportsbook.sbtech_api_impl.yourBet && doOpen) {
    return;
  }
  _betslipEl.classList[doOpen ? 'add' : 'remove'](styleClasses.BETSLIP_OPEN);
  if (isSelfService && _sportsbookBetslipStateChangeHandler) {
    _sportsbookBetslipStateChangeHandler();
  }
}
function setIsBetslipOpen(isBetslipOpen) {
  _isBetslipOpen = isBetslipOpen;
  toggle();
}
function updateCount(itemsCount) {
  if (_betslipItemCount !== itemsCount && itemsCount !== 0) {
    _betslipEl.classList.add(styleClasses.BETSLIP_ADD_ITEM);
  }
  _betslipItemCount = itemsCount;
  if (isSelfService && itemsCount === 0) {
    _betslipItemCountEl.innerText = '';
    _betslipTextEl.innerText = 'Gör dina val och välj sen insats';
    _betslipCol2.classList.add('bg-grey-330');
  } else {
    _betslipItemCountEl.innerText = itemsCount;
    _betslipTextEl.innerText = '\u00a0Oddset objekt valt';
    _betslipCol2.classList.remove('bg-grey-330');
  }
  toggle();
}
function setShouldShowBetslip(shouldShowBetslip) {
  _shouldShowBetslip = shouldShowBetslip;
  if (!shouldShowBetslip && _betslipEl) {
    _betslipEl.style.display = 'none';
  }
}
function getBetslipCount() {
  return _betslipItemCount;
}
svs.sportsbook.sbtech_api_impl.betslip = {
  setShouldShowBetslip,
  setIsBetslipOpen,
  render,
  updateCount,
  getBetslipCount
};

 })(window);